<template>
    <div class="animated fadeIn">
        <p v-if="loading" style="text-align: center;padding: 20px">
            <span style="font-size: 25px;">
                <i class="fa fa-spinner fa-spin"></i> Loading...
            </span>
        </p>
        <b-row v-else>
            <b-col lg="12" sm="12" md="12" xs="12">
                <b-card-group deck>
                    <b-card header="All Active Loans">
                        <div v-if="tableData.length < 1">
                            <p style="font-size: 15px;" class="text-center">
                                <i>There are currently no active loans.</i>
                            </p>
                        </div>
                        <div v-else>
                            <v-client-table else :data="tableData" :columns="columns" :options="options">
                                <div slot="status" >
                                    <b-badge variant="success" pill>Disbursed</b-badge>
                                </div>
                            </v-client-table>
                        </div>
                    </b-card>
                </b-card-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { baseURL } from '../../shared/utils';
import { mapState, mapActions } from 'vuex';
import { getLoanByStatus } from '@/services/loanService';

export default {
    name: 'disbursedlist',
    data: () => {
        return {
            columns: ['id', 'name', 'type', 'reason', 'amount', 'status', 'date', 'disbursed_by', 'reference'],
            tableData: [],
            loading: false,
            options: {
                headings: {
                    id: 'S/N',
                    name: 'Customer Name',
                    type: 'Loan Type',
                    reason: 'Loan Reason',
                    amount: 'Amount(₦)',
                    status: 'Status',
                    disbursed_by: 'Disbursed By',
                    date: 'Date',
                    reference: 'Reference'
                },
                sortable: ['name', 'status', 'type'],
                filterable: ['name', 'amount']
            }
        }
    },
    created () {
        this.fetchData(1);
    },
    methods: {
        async fetchData(page_number) {
            this.loading = true;
            try {
                this.tableData = [];
                let {data} = await getLoanByStatus(5);

                data.loans.map((loan, index) => {
                    this.tableData.push({
                        id: ++index,
                        name: `${loan.user.first_name} ${loan.user.last_name}`,
                        type: loan.loan_type.name,
                        reason: loan.loan_reason.name,
                        amount: `₦${parseInt(loan.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
                        status: loan.loan_status_id,
                        disbursed_by: `${loan.disbursed_by.first_name} ${loan.disbursed_by.last_name}`,
                        date: loan.updated_at,
                        reference: loan.reference
                    });
                });
            }
            catch(error) {
                console.log(error);
            }
            finally {
                this.loading = false;
            }
        }
    }
}
</script>
